/**
 * Trang lỗi dùng chung (FR-144). Không hiển thị dữ liệu giả.
 *
 * `ComingSoonPage` từng ở đây cho các màn thuộc M3–M7. Bảy mốc đã bàn giao và
 * route giữ chỗ cuối cùng (`/dns`) nay chuyển hướng về `/domains` (OQ-095), nên
 * không còn ai dùng — đã gỡ cùng hai khoá i18n `state.comingSoon.*`.
 */

import { Link, useRouteError } from 'react-router-dom';
import { useT } from '../lib/i18n';
import { EmptyState } from '../components/States';

export function NotFoundPage() {
  const t = useT();
  return (
    <div className="card">
      <EmptyState
        icon="warn"
        title={t('state.notFound.title')}
        body={t('state.notFound.body')}
        action={
          <Link className="btn" to="/">
            {t('common.backToOverview')}
          </Link>
        }
      />
    </div>
  );
}

export function RouteErrorPage() {
  const t = useT();
  const error = useRouteError();
  const message = error instanceof Error ? error.message : undefined;

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <EmptyState
          icon="warn"
          title={t('state.error.title')}
          body={message ?? t('state.error.body')}
          action={
            <a className="btn btn-primary" href="/">
              {t('common.backToOverview')}
            </a>
          }
        />
      </div>
    </div>
  );
}
